module.exports = __webpack_public_path__ + "static/media/bar-brewery-winery-4.e7785c03.jpg";